(function (angular, app) {
    "use strict";

    angular.module(app.modules.outing.name)
       .controller(app.modules.outing.routes.setup.controller, OutingSetupController);

    OutingSetupController.$inject = ["$scope", "$q", "$routeParams", "ngDialog"
       , app.modules.common.services.storage
       , app.modules.group.services.groups
       , app.modules.outing.services.outings
       , app.modules.common.constants.appmessaging
       , app.modules.common.services.functions
       , app.modules.ui.services.alerts
       , app.modules.common.constants.gameenum
       , app.modules.common.constants.themelist
       , app.modules.invitation.services.invite
    ];

    function OutingSetupController($scope, $q, $routeParams, ngDialog
       , ggStorage
       , ggGroupSvc
       , ggOutingSvc
       , ggMessaging
       , ggFunctions
       , ggAlertSvc
       , ggGameEnum
       , ggThemes,
        ggInvitationSvc
    ) {

        // Scope the Outing
        $scope.Outing = null;
        $scope.PopupAlert = new ggAlertSvc.popup();

        // Assign this to object. Who want's to work with this?
        var ctrl = this;

        $scope.Temp = {
            isLoaded: false
           , themes: ggThemes
           , types: app.modules.outing.types
           , handicapTypes: app.modules.group.constants.handicapTypes
        }

        $scope.Defaults = {
            courseId: 0
           , courseObj: {}
           , groupId: 0
           , groupObj: {}
           , playDate: ggFunctions.formatDateString(null, 'yyyy-mm-dd', null)
           , startTime: null
           , holesPlayed: "EighteenHoles"
           , isAdvanced: false
        }

        $scope.Setup = {
            isDirty: false
           , form: {
               outingId: 0
              , groupId: "0"
              , roundId: 0
              , themeId: "1"
              , courseId: 0
              , gameCourseId: 0
              , name: ""
              , description: ""
              , classType: "PrivateInvitationOnly"
              , gameType: "Individual"
              , holeType: "EighteenHoles"
              , scoringType: "Stroke"
              , pointType: "None"
              , handicapType: "Official"
              , startOn: null
              , startTime: null
              , isNet: false
              , isLowHandicap: false
              , isSkins: false
              , isWager: false
              , isActive: true
              , maxSkinStrokes: 1
              , bestBallCount: 1
              , agree: 0
              , teeTimeId: 0
              , isMultipleTeeTimes: false
              , teeTimeInterval: "9"
              , teeTimeCount: "1"
           }
           , show: function () {

               // Set form from defaults
               $scope.Setup.form.courseId = $scope.Defaults.courseId;
               $scope.Setup.form.groupId = $scope.Defaults.groupId;
               $scope.Setup.form.holeType = $scope.Defaults.holesPlayed;

               ggFunctions.scrollToTop(0);
               $scope.Temp.isLoaded = true;

           }
           , manage: function () {
               ggFunctions.goToPage(app.modules.outing.routes.detail.path + "?outingId=" + $scope.Setup.form.outingId);
           }
           , processForm: {
               isError: false
              , responseMsg: ""
              , fail: function (data) {
                  $scope.Setup.processForm.isError = true;
                  $scope.Setup.processForm.responseMsg = data.msg;
              }

              , save: function (isValid) {
                  // Save Outin
                  $scope.Setup.isDirty = true;
                  $scope.Setup.processForm.isError = false;
                  if (isValid) {

                      var outing = $scope.Setup.outing.insert;
                      var round = $scope.Setup.round.insert;
                      var course = $scope.Setup.course.insert;
                      var teetime = $scope.Setup.teetime.insert;
                      var game = $scope.Setup.game.insert;
                      var players = $scope.Setup.players.insert;

                      // Process 
                      ggFunctions.toggleProcessing(true);
                      return outing().then(function () {
                          if (!$scope.Setup.processForm.isError)
                              return app.Member.Authenticate.RefreshToken();
                      }).then(function () {
                          return round();
                      }).then(function () {
                          if (!$scope.Setup.processForm.isError)
                              return course();
                      }).then(function () {
                          if (!$scope.Setup.processForm.isError)
                              return teetime();
                      }).then(function () {
                          if (!$scope.Setup.processForm.isError)
                              return game();
                      }).then(function () {
                          if (!$scope.Setup.processForm.isError) {
                              return players();
                          }
                      }).then(function () {
                          if (!$scope.Setup.processForm.isError) {
                              return insertInvitations();
                          }
                      }).finally(function () {
                          ggFunctions.toggleProcessing(false);
                          if ($scope.Setup.processForm.isError) {
                              $scope.PopupAlert.fail("Error", $scope.Setup.processForm.responseMsg);
                          } else {

                              // Reset Local
                              ggStorage.set(ggStorage.keys.outings.organizer.isCurrent, false);

                              var isNew = "&isNew";

                              if ($scope.Setup.invitemember.results.length > 0) {
                                  isNew = "";
                              }

                              // Save to form.
                              var btn = new ggAlertSvc.button;
                              btn.name = "Continue";
                              btn.path = app.modules.outing.routes.detail.path + "?outingId=" + $scope.Setup.form.outingId + "&teeTimes=" + $scope.Setup.form.teeTimeCount + isNew;
                              $scope.PopupAlert.success("Outing Created!", "Tap continue to manage the outing.", [btn]);
                          }
                      });
                  }
              }
           }
           , outing: {
               insert: function () {
                   var form = angular.copy($scope.Setup.form);
                   form.handicapType = $scope.Defaults.groupObj.handicapType;
                   if (form.classType == "Manual") {
                       form.classType = "PrivateInvitationOnly"
                   }
                   return ggOutingSvc.setup.insertOuting(form).then(function (data) {
                       if (data && data.status == "201") {
                           // Save to form.
                           $scope.Setup.form.outingId = data.data.id;
                       }
                       return;
                   }, function (error) {
                       $scope.Setup.processForm.fail({ msg: "Failed to setup outing detail." });
                       return;
                   });
               }
           }
           , round: {
               insert: function () {
                   var data = {
                       outingId: $scope.Setup.form.outingId
                      , name: "Round #1"
                      , number: 1
                      , startOn: $scope.Setup.form.startOn
                      , endOn: $scope.Setup.form.startOn
                   }
                   if (data.outingId > 0) {
                       return ggOutingSvc.round.insertRound(data).then(function (data) {
                           if (data && data.status == "201") {
                               // Save to form.
                               $scope.Setup.form.roundId = data.data.id;
                           }
                           return;
                       }, function (error) {
                           $scope.Setup.processForm.fail({ msg: "Failed to setup outing detail." });
                           return;
                       });
                   } else {
                       $scope.Setup.processForm.fail({ msg: "The proper information was not available to setup the round." });
                       return $q.resolve();
                   }
               }
           }
           , course: {
               insert: function () {
                   var data = {
                       outingId: $scope.Setup.form.outingId
                      , courseId: $scope.Setup.form.courseId
                   }
                   if (data.outingId > 0 && data.courseId > 0) {
                       return ggOutingSvc.course.insertCourseFull(data).then(function (data) {
                           if (data && data.status == "200") {
                               // Save to form.
                               $scope.Setup.form.gameCourseId = data.data.value;
                           }
                           return;
                       }, function (error) {
                           $scope.Setup.processForm.fail({ msg: "Failed to setup course information." });
                           return;
                       });
                   } else {
                       $scope.Setup.processForm.fail({ msg: "The proper information was not available to setup the course." });
                       return $q.resolve();
                   }

               }
           }
           , teetime: {
               insert: function () {





                   if ($scope.Setup.form.outingId > 0 && $scope.Setup.form.roundId > 0 && $scope.Setup.form.gameCourseId > 0) {

                       var isTTOK = true;
                       var process = function (form) {
                           return ggOutingSvc.teetime.insertTeeTime(form).then(function (data) {
                               if (data && data.status == "201") {
                                   // Save to form.
                                   $scope.Setup.form.teeTimeId = data.data.id;
                               }
                               return;
                           }, function (error) {
                               isTTOK = false;
                               return;
                           });
                       }



                       var dataset = [];
                       for (var tt = 0; tt < $scope.Setup.form.teeTimeCount; tt++) {
                           var startTime = $scope.Setup.form.startTime || "08:00:00";

                           var tmpDate = "01/01/2016 " + startTime;
                           var later = new Date(tmpDate);
                           later.setMinutes(later.getMinutes() + ((tt) * $scope.Setup.form.teeTimeInterval));
                           var newStartTime = dateFormat(later, "hh:MM TT");


                           var data = {
                               outingId: $scope.Setup.form.outingId
                              , roundId: $scope.Setup.form.roundId
                              , gameCourseId: $scope.Setup.form.gameCourseId
                              , startingHole: 1
                              , teeTimeNumber: tt + 1
                              , startingTime: newStartTime
                           }
                           dataset.push(data);
                       }

                       return ggFunctions.qSequence(process, dataset).finally(function (data) {
                           if (!isTTOK) {
                               $scope.Setup.processForm.fail({ msg: "Failed to setup teetime information." });
                           } else {
                               return;
                           }
                       });


                   } else {
                       $scope.Setup.processForm.fail({ msg: "The proper information was not available to setup the teetime." });
                       return $q.resolve();
                   }





               }
           }
           , game: {
               insert: function () {

                   // Best Balls
                   var bestBalls = app.modules.outing.constants.defaultBestBalls;
                   if ($scope.Setup.form.bestBallCount > 1) {
                       bestBalls = {
                           hole1: $scope.Setup.form.bestBallCount
                       , hole2: $scope.Setup.form.bestBallCount
                       , hole3: $scope.Setup.form.bestBallCount
                       , hole4: $scope.Setup.form.bestBallCount
                       , hole5: $scope.Setup.form.bestBallCount
                       , hole6: $scope.Setup.form.bestBallCount
                       , hole7: $scope.Setup.form.bestBallCount
                       , hole8: $scope.Setup.form.bestBallCount
                       , hole9: $scope.Setup.form.bestBallCount
                       , hole10: $scope.Setup.form.bestBallCount
                       , hole11: $scope.Setup.form.bestBallCount
                       , hole12: $scope.Setup.form.bestBallCount
                       , hole13: $scope.Setup.form.bestBallCount
                       , hole14: $scope.Setup.form.bestBallCount
                       , hole15: $scope.Setup.form.bestBallCount
                       , hole16: $scope.Setup.form.bestBallCount
                       , hole17: $scope.Setup.form.bestBallCount
                       , hole18: $scope.Setup.form.bestBallCount
                       }
                   }

                   // Skins
                   var maxSkinStrokes = null;
                   if ($scope.Setup.form.isSkins) {
                       maxSkinStrokes = $scope.Setup.form.maxSkinStrokes
                   }

                   // Points
                   var pointType = $scope.Setup.form.pointType
                   var points = app.modules.outing.constants.defaultPoints;

                   var data = {
                       outingId: $scope.Setup.form.outingId
                      , name: "Game #1"
                      , gameType: $scope.Setup.form.gameType
                      , scoringType: $scope.Setup.form.scoringType
                      , holeType: $scope.Setup.form.holeType
                      , pointType: pointType
                      , isMain: true
                      , isNet: $scope.Setup.form.isNet
                      , isLowHandicap: $scope.Setup.form.isLowHandicap
                      , isSkins: $scope.Setup.form.isSkins
                      , isWager: $scope.Setup.form.isWager
                      , maxSkinStrokes: maxSkinStrokes
                      , points: points
                      , bestBalls: bestBalls
                   }
                   if (data.outingId) {
                       return ggOutingSvc.game.insertGame(data).then(function (data) {
                           return;
                       }, function (error) {
                           $scope.Setup.processForm.fail({ msg: "Failed to setup game information." });
                           return;
                       });
                   } else {
                       $scope.Setup.processForm.fail({ msg: "The proper information was not available to setup the game." });
                       return $q.resolve();
                   }

               }
           }
           , players: {
               //
               // Add players to outing
               // Add players to teetime
               insert: function () {
                   if ($scope.Setup.invitemember.results.length > 0) {
                       var form;
                       var members = [];
                       // THey have to be in the group.
                       var insertPlayerMembership = function (memberId) {
                           return ggGroupSvc.membership.autoJoinGroup({ groupId: $scope.Setup.form.groupId, memberId: memberId }).then(function (data) {
                               return ggOutingSvc.player.insertPlayer({ outingId: $scope.Setup.form.outingId, memberId: memberId }).then(function (data) {
                                   var playerId = data.data.id;

                                   if ($scope.Setup.form.teeTimeCount == 1 && members.length < 7) {
                                       return ggOutingSvc.teetime.addPlayer({ outingId: $scope.Setup.form.outingId, teeTimeId: $scope.Setup.form.teeTimeId, playerId: playerId }).then(function (data) {
                                           return;
                                       }, function (error) {
                                           $scope.Setup.processForm.fail({ msg: "There was an error adding the player to the tee time." });
                                           return;
                                       });
                                   } else {
                                       return $q.resolve();
                                   }

                               }, function (error) {
                                   $scope.Setup.processForm.fail({ msg: "There was an error adding the member to the outing." })
                                   return;
                               });
                           });
                       }

                       for (var x = 0; x < $scope.Setup.invitemember.results.length; x++) {
                           var member = members.push($scope.Setup.invitemember.results[x].id);
                       }

                       return ggFunctions.qSequence(insertPlayerMembership, members);

                   } else {
                       return $q.resolve();
                   }

               }
           }
           , invitemember: {
               results: [] // List of members to send invitation
              , buttonText: "Add Players to Roster"
              , swipe: {
                  selected: 0
                    , left: function (memberId) {
                        $scope.Setup.invitemember.swipe.selected = memberId;
                    }
                    , right: function (memberId) {
                        $scope.Setup.invitemember.swipe.selected = 0;
                    }
                    , isSelected: function (memberId) {
                        return memberId == $scope.Setup.invitemember.swipe.selected;
                    }
              }
              , remove: function (memberId) {

                  // build a promise list
                  for (var r = 0; r < $scope.Setup.invitemember.results.length; r++) {
                      var m = $scope.Setup.invitemember.results[r];
                      if (m && m.id == memberId) {
                          $scope.Setup.invitemember.results.splice(r, 1);
                          $scope.Setup.invitemember.swipe.selected = 0;
                          break;
                      }
                  }
              }
           }

        }

        $scope.f = {
            updateStartOn: function (data) {
                if (data) {
                    $scope.Defaults.playDate = data.date;
                    $scope.Setup.form.startOn = data.date;
                }
            }
           , pickMembers: function (data) {
               // Should be a list of members
               var isMemberSelected = function (memberId) {
                   var y = false;
                   for (var m = 0; m < $scope.Setup.invitemember.results.length; m++) {
                       if (memberId == $scope.Setup.invitemember.results[m].id) {
                           y = true;
                           break;
                       }
                   }
                   return y;
               }

               if (data && data.length > 0) {
                   var ex = 0;
                   for (var x = 0; x < data.length; x++) {
                       // Make sure they don't exist
                       var isEx = isMemberSelected(data[x].id);
                       if (!isEx) {
                           ex++;
                           $scope.Setup.invitemember.results.push(data[x]);
                           //if (x >= 5) {
                           //    break;
                           //}
                       }
                   }
                   $scope.Setup.invitemember.buttonText = "Add More Players to Roster";
               } else {
                   $scope.Setup.invitemember.buttonText = "Add Players to Roster";
               }
           }
           , updateStartTime: function (data) {
               if (data) {
                   $scope.Defaults.startTime = data.time;
                   $scope.Setup.form.startTime = data.time;
               }
           }
           , updateCourse: function (course) {

               if (course && course.id) {
                   $scope.Setup.form.courseId = course.id;
                   $scope.Setup.form.course = course;

                   $scope.Defaults.courseObj = course;
                   $scope.Defaults.courseId = course.id;

               }
           }
           , updateGroup: function (group) {
               if (group && group.id) {
                   $scope.Setup.form.groupId = group.id;
                   $scope.Defaults.groupObj = group;
                   $scope.Defaults.groupId = group.id;
               }
           }
           , toggleAdvanced: function () {
               $scope.Defaults.isAdvanced = !$scope.Defaults.isAdvanced;
           }
        }

        // Request parameters
        if ($routeParams) {

            var isOK = true;
            var rmsg = "";


            var ndate = new Date();
            var now = ndate.getTime();
            var nm = now.toString().substr(now.toString().length - 4, 4);

            // Update Outing Name
            var today = ggFunctions.formatDateString($scope.Setup.form.startOn, "mm/dd", null)



            var outingName = "Outing " + today + "-" + nm;

            var _group = function (groupId) {

                // Set requested group, but verify we can organize
                var defaultGroupId = 0;
                var defaultGroupObj = {};
                if (groupId) {
                    defaultGroupId = groupId;
                } else {
                    defaultGroupId = ggStorage.get(ggStorage.keys.member.prefs.group.groupId) || 0;
                }

                var processData = function (mygroups) {
                    // Verify groupID against my organizer groups
                    var isOrg = false;
                    if (defaultGroupId > 0) {
                        for (var g = 0; g < mygroups.length; g++) {
                            if (defaultGroupId == mygroups[g].group.id) {
                                $scope.Defaults.groupObj = mygroups[g].group;
                                $scope.Defaults.groupId = defaultGroupId;
                                isOrg = true;
                                break;
                            }
                        }
                    }

                    if (!isOrg && mygroups.length == 1) {
                        $scope.Defaults.groupObj = mygroups[0];
                        $scope.Defaults.groupId = mygroups[0].id;
                        isOrg = true;
                    }

                    /*
                    if (!isOrg && mygroups.length == 0) {
                        isOK = false;
                        var btn = new ggAlertSvc.button;
                        btn.path = app.modules.group.routes.setup.path;
                        btn.name = "OK";
                        $scope.PopupAlert.warn("No Groups", "You are not organizing any groups.  Tap OK to setup your first group.", [btn]);

                    }
                    */
                    return $q.resolve();
                }

                    // local group

                   
                    return app.Member.Network.Data.Groups.allmygroups.fetch(true).then(function (data) {
                        return processData(data);
                    });

            }

            var _course = function (courseId) {
                var defaultCourseId = 0;
                var defaultCourseObj = {};
                var isCourse = false;

                if (courseId) {
                    defaultCourseId = courseId;
                } else {
                    defaultCourseId = app.Member.Detail.preferenceSettings.defaultCourseId;
                    defaultCourseObj = JSON.parse(ggStorage.get(ggStorage.keys.member.prefs.course.courseObj)) || {};
                    if (defaultCourseId > 0 && defaultCourseObj && defaultCourseObj.name) {
                        isCourse = true;
                    }
                }

                var processData = function (mycourses) {

                    if (!isCourse) {
                        if (defaultCourseId > 0) {
                            for (var g = 0; g < mycourses.length; g++) {
                                if (mycourses[g].id == defaultCourseId) {
                                    $scope.Defaults.courseObj = mycourses[g];
                                    $scope.Defaults.courseId = defaultCourseId;
                                    isCourse = true;
                                    break;
                                }
                            }
                        }

                        if (!isCourse){
                           if (defaultCourseId == 0){
                              if ($scope.Defaults.courseId == 0 && mycourses.length == 1) {
                                 $scope.Defaults.courseObj = mycourses[0];
                                 $scope.Defaults.courseId = mycourses[0].id;
                              }
                           }else{
                              $scope.Defaults.courseId = defaultCourseId;
                           }
                        }
                        

                    } else {
                        $scope.Defaults.courseObj = defaultCourseObj;
                        $scope.Defaults.courseId = defaultCourseId;
                    }
                    return $q.resolve();
                }

                // local courses
                var isCurrent = ggStorage.get(ggStorage.keys.courses.my.isCurrent);
                var storeData = JSON.parse(ggStorage.get(ggStorage.keys.courses.my.data)) || [];

                if (!isCurrent || !storeData || (storeData && storeData.length == 0)) {
                    ggFunctions.toggleProcessing(true);
                    return app.Member.Network.Data.Courses.fetch(true).then(function (data) {
                        return processData(data);
                    });
                } else {
                    return processData(storeData);
                }
            }

            var _playdate = function (playDate) {

                if (playDate) {
                    $scope.Defaults.playDate = $routeParams.playDate;
                }

                $scope.Defaults.holesPlayed = "EighteenHoles";
                $scope.Setup.form.name = $scope.Defaults.playDate;
                return $q.resolve();
            }


            var _outings = function () {

                var isCurrent = ggStorage.get(ggStorage.keys.outings.organizer.isCurrent);
                var storeData = JSON.parse(ggStorage.get(ggStorage.keys.outings.organizer.data)) || [];
                var processData = function (d) {
                    if (d.length > 0) {
                        //outingName = "Outing #" + d.length;
                    }
                    return $q.resolve();
                }

                if (!isCurrent || !storeData || storeData.length == 0) {
                    return app.Member.Network.Data.Outings.organizer.fetch(true).then(function (data) {
                        return processData(data);
                    });
                } else {
                    return processData(storeData);
                }
            }

            ggFunctions.toggleProcessing(true);
            _group($routeParams.groupId).then(function () {
                return _course($routeParams.courseId);
            }).then(function () {
                return _playdate($routeParams.playDate);
            }).then(function () {
                return _outings();
            }).finally(function () {

                // Set Form
                $scope.Setup.form.name = outingName;
                $scope.Setup.form.groupId = $scope.Defaults.groupId;
                $scope.Setup.form.gameCourseId = $scope.Defaults.courseId;

                ggFunctions.toggleProcessing(false);
                if (isOK) {
                    $scope.Setup.show();

                }

            });

        }

        function insertInvitations() {
            var members = $scope.Setup.invitemember.results,
                fail = $scope.Setup.processForm.fail,
                outingId = $scope.Setup.form.outingId;

            return $q.all(members.map(map));

            function map(member) {
                member = { outingId: outingId, memberId: member.id, firstName: member.firstName, lastName: member.lastName, email: member.email, responseType: 'Accepted' };
                return ggInvitationSvc.invite
                    .insertInvitation(member)
                    .catch(fail.bind(null, { msg: "There was an error sending the invitations." }));
            }
        }
    }
}(angular, app));

